<script>
  // ── Eine Zeile der Bestandsliste — ein Markup, zwei Breiten (A7/L6) ───────
  //
  // Der Entwurf zeichnet zwei Zeilen: vierspaltig ab 600 px (Name | Skala |
  // Menge | Aktion) und zweizeilig auf 390 px (Name + Warengruppe · Menge über
  // der vollen Skalenbreite). Gebaut ist EIN Markup mit immer denselben
  // Kindern; das Raster ordnet sie um (Plan 1.5, Vorschlag 2).
  //
  // DIE EINE STELLE, AN DER DAS KLEMMT (Plan 14.7)
  // Schmal bilden Warengruppe und Menge EINEN Textfluss („Mehl · 18,2 kg"),
  // breit verschwindet die Warengruppe (sie steht im Gruppenkopf) und die Menge
  // wird eine eigene, rechtsbündige Spalte. Gelöst über `display: contents` auf
  // der Meta-Hülle plus einen eigenen Trenner, der sich ausblenden lässt —
  // dieselbe Technik wie in Reichweite.svelte, damit es sie im Modul genau
  // einmal zu verstehen gibt.
  //
  // DIE TREFFERFLÄCHE (seit L7)
  // Der Entwurf legt eine Fläche über die GANZE Zeile (`.a-row__hit`), nicht
  // einen Link auf den Namen — Fitts: Das Ziel ist so groß wie die Zeile. Sie
  // liegt als letztes Kind absolut über allem und trägt einen z-index über dem
  // des Reichweiten-Satzes, der selbst positioniert ist. Der Weg des Kits
  // (`pointer-events: none` auf allen Geschwistern) geht hier NICHT: Die
  // Kinder der Reichweite tragen deren Scope-Klasse, und ein Selektor von hier
  // aus träfe sie nicht.
  //
  // Ein Knopf, kein Link: Es gibt keine Adresse, auf die er zeigen könnte —
  // das Detail ist Zustand der Insel, nicht Route (Plan 17.6).
  //
  // Weiterhin NICHT da: der 36-px-Knopf „Eingang für diese Zutat". Er führte in
  // dieselbe leere Maske wie der CTA, weil EingangBuchen keine Vorbelegung
  // kennt. Kein Knopf, der nichts tut (Plan 14.4).
  //
  // EBENFALLS NICHT DA: eine Marke für den außerplanmäßigen Abgang (Plan 20).
  // Sie stand einen Tag lang hier, als Punkt hinter der Menge, und war zweimal
  // falsch: Ein Punkt ohne Text liest sich als „ungelesen", und er saß an der
  // Rohstoffmenge — die ist genau, ungenau ist die PROGNOSE. Der Hinweis lebt
  // im Detail, wo Platz für den ganzen Satz ist.
  import Reichweite from './Reichweite.svelte';

  /** @type {{ zeile: any, onoeffnen: () => void }} */
  let { zeile, onoeffnen } = $props();

  const t = (k, p) => window.t(k, p);

  let menge   = $derived(window.lagerMenge(zeile.bestand));
  let anzeige = $derived(window.lagerReichweiteAnzeige(zeile.prognose));
  let fehlt   = $derived(anzeige.zustand === 'fehlt');
</script>

<div class="lg-zeile" class:lg-zeile--fehlt={fehlt}>
  <div class="lg-zeile__kopf">
    <span class="lg-zeile__name">{zeile.name}</span>
    <span class="lg-zeile__meta">
      <span class="lg-zeile__grp">{zeile.anzeigeGruppe || zeile.warengruppe}</span>
      <span class="lg-zeile__sep" aria-hidden="true">·</span>
      <span class="lg-zeile__menge">
        <b>{menge.wert}</b><span class="lg-zeile__einheit">{menge.einheit}</span>
      </span>
    </span>
  </div>

  <Reichweite {anzeige} dichte="zeile" />

  <button type="button" class="lg-zeile__hit" onclick={onoeffnen}
          aria-label={t('lager_detail_oeffnen', { name: zeile.name })}></button>
</div>

<style>
  /* Schmal ist der Ausgangspunkt: zwei Spalten, zwei Zeilen. Links Name und
     Meta, rechts die Aussage der Reichweite, darunter über die volle Breite
     die Skala. Die zweite Spalte ist `auto` — die Aussage bestimmt ihre
     Breite, nicht umgekehrt. */
  .lg-zeile {
    /* Traegt die Trefferflaeche und den Stapelkontext, in dem sie ueber dem
       Satz der Reichweite liegt. */
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 4px 12px;
    padding: 12px 16px;
    background: var(--lg-card);
    border-bottom: 1px solid var(--lg-line-fein);
    /* Reichweite.svelte legt den Satz auf diesen Grund, damit die Spur nicht
       in Schrifthöhe hinter ihm durchläuft (Plan 14.14). Er wird hier gesetzt,
       weil nur die Zeile weiß, worauf sie steht. */
    --lg-zeilengrund: var(--lg-card);
  }
  .lg-zeile:last-child { border-bottom: 0; }

  /* Die Fehlmenge trägt Kantenmarke UND Fläche — Form trägt mit, nicht Fläche
     allein, damit eine dichte Liste nicht alarmistisch wirkt. */
  .lg-zeile--fehlt {
    background: var(--lg-fehlt-bg);
    box-shadow: inset 3px 0 0 var(--lg-fehlt-edge);
    --lg-zeilengrund: var(--lg-fehlt-bg);
  }

  /* Ueber allem, auch ueber dem Satz der Reichweite (z-index: 1). Unsichtbar,
     aber fokussierbar — die Tastatur erreicht die Zeile ueber sie. */
  .lg-zeile__hit {
    position: absolute;
    inset: 0;
    z-index: 2;
    border: 0;
    background: none;
    padding: 0;
    cursor: pointer;
  }
  .lg-zeile__hit:focus-visible { outline: 2px solid var(--lg-ink); outline-offset: -2px; }
  .lg-zeile:hover { background: var(--lg-tint); }
  .lg-zeile--fehlt:hover { background: #ffe4e6; }

  .lg-zeile__kopf { min-width: 0; }
  .lg-zeile__name {
    display: block;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.005em;
    color: var(--lg-ink);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lg-zeile__meta {
    display: block;
    margin-top: 2px;
    font-size: 11.5px;
    color: var(--lg-ink-mute);
    font-variant-numeric: tabular-nums;
  }
  .lg-zeile--fehlt .lg-zeile__meta { color: var(--lg-fehlt-ink); }
  .lg-zeile__sep { margin: 0 3px; }
  /* Die Warengruppe ist Beiwerk, die Menge ist die Auskunft. Schmal standen
     beide in derselben blassen Zeile — die Zahl, wegen der man hinsieht, war
     die am schlechtesten lesbare. Sie bekommt deshalb dieselbe Behandlung wie
     breit: kräftiger, dunkler, und bei einer Fehlmenge in deren Farbe. Die
     Abstufung liegt jetzt auf dem Beiwerk, nicht mehr auf der ganzen Zeile. */
  .lg-zeile__grp, .lg-zeile__sep { opacity: 0.75; }
  .lg-zeile__menge { font-size: 13px; font-weight: 600; color: var(--lg-ink-soft); }
  .lg-zeile--fehlt .lg-zeile__menge { color: var(--lg-fehlt-ink); }
  .lg-zeile__einheit { margin-left: 2px; font-size: 11.5px; color: var(--lg-ink-mute); }
  .lg-zeile--fehlt .lg-zeile__einheit { color: var(--lg-fehlt-ink); opacity: 0.75; }

  /* ── Ab 600 px: Name | Skala | Menge ──────────────────────────────────────
     Der Entwurf hat eine vierte Spalte für den Zeilen-Knopf; sie entfällt in
     L6 mitsamt dem Knopf. Der 860-px-Bruchpunkt des Kits entfällt ebenfalls:
     ein Breakpoint im Modul, und es ist der der App (Plan 14.2). */
  @container (min-width: 600px) {
    .lg-zeile {
      /* Aus Lager.svelte, weil die Achse ueber der Karte dasselbe Raster
         braucht (Plan 17.11). */
      grid-template-columns: var(--lg-zeilen-raster);
      gap: 0 var(--lg-zeilen-abstand);
      min-height: 52px;
      padding: 8px 20px;
    }
    /* Kopf und Meta geben ihre Boxen auf, damit Name und Menge eigene
       Rasterzellen werden — die Warengruppe steht dann im Gruppenkopf. */
    .lg-zeile__kopf,
    .lg-zeile__meta { display: contents; }
    .lg-zeile__grp,
    .lg-zeile__sep { display: none; }
    /* Zeile 1 AUSDRUECKLICH: Ohne sie platziert das Raster den Namen (Spalte 1)
       und die Menge (Spalte 3) automatisch, der Zeiger steht danach am Ende der
       ersten Zeile — und die Reichweite mit ihrer festen Spalte 2 rutscht in
       eine zweite Zeile. Genau so stand sie im ersten Durchgang unter dem Namen
       statt neben ihm (Plan 14.16). */
    .lg-zeile__name { grid-column: 1; grid-row: 1; font-size: 14px; }
    .lg-zeile__menge {
      grid-column: 3;
      grid-row: 1;
      text-align: right;
      font-size: 13.5px;
      font-weight: 600;
      color: var(--lg-ink-soft);
      font-variant-numeric: tabular-nums;
    }
    .lg-zeile--fehlt .lg-zeile__menge { color: var(--lg-fehlt-ink); }
    .lg-zeile__einheit { font-size: 11.5px; color: var(--lg-ink-mute); }
    .lg-zeile--fehlt .lg-zeile__einheit { color: var(--lg-fehlt-ink); opacity: 0.7; }
  }
</style>
